import React, { useState, useEffect } from "react";
import "./CalorieCounter.css";
import BackBtn from "../../Components/BackBtn/BackBtn";
import HamburgerMenu from "../../Components/HamburgerMenu/HamburgerMenu";
import Help from "../../Components/Help/Help";
import calorieCounterHelp from "./calorieCounterHelp";
import CaloriesPerDay from "./CaloriesPerDay/CaloriesPerDay";
import Meals from "./Meals/Meals";
import DailyFood from "./DailyFood/DailyFood";
import MealsList from "./MealsList/MealsList";
import CoachComments from "./CoachComments/CoachComments";
import BottomBar from "../../Components/BottomBar/BottomBar";
import MobileDatePicker from "../../Components/MobileDatePicker/MobileDatePicker";
import Alert from "../../Components/Alert/Alert";
import JalaliMoment from "jalali-moment";
import Modal from "react-bootstrap/Modal";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import useCalorie from "../../Hooks/useCalorie";
import { useBaseUrl } from "../../ApiContext";

export default function CalorieCounter() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [shamsiDate, setShamsiDate] = useState("");
  const { calorieData, setCalorieData } = useCalorie(userToken, shamsiDate);
  const [carbohydratesData, setCarbohydratesData] = useState(null);
  const [proteinData, setProteinData] = useState(null);
  const [fatData, setFatData] = useState(null);
  const [calorieInputVal, setCalorieInputVal] = useState(0);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const [showQuestionModal, setShowQuestionModal] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [manualCalculator, setManualCalculator] = useState(null);
  const [showCalorieRegulationModal, setShowCalorieRegulationModal] =
    useState(false);
  const [alertText, setAlertText] = useState("");
  const [showSwitchAlert, setShowSwitchAlert] = useState(false);
  const [switchAlertText, setSwitchAlertText] = useState("");
  const [comment, setComment] = useState("");
  const [mealsData, setMealsData] = useState(null);

  useEffect(() => {
    const fetchToday = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/today`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setShamsiDate(response.data.dates.current_date);
        setComment(response.data.comment);
      } catch (error) {
        console.log("Error during today request", error);
      }
    };
    const fetchAutoCalorie = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/auto_calorie`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setManualCalculator(response.data.manual_calculate_calorie);
      } catch (error) {
        console.log("Error during auto calorie request", error);
      }
    };

    if (userToken) {
      fetchToday();
      fetchAutoCalorie();
    }
  }, [baseUrl, userToken]);

  useEffect(() => {
    const fetchCarbohydrates = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/carbohydrates/${shamsiDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setCarbohydratesData(response.data);
      } catch (error) {
        console.log("Error during carbohydrates request", error);
      }
    };
    const fetchProtein = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/protein/${shamsiDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setProteinData(response.data);
      } catch (error) {
        console.log("Error during protein request", error);
      }
    };
    const fetchFat = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/fat/${shamsiDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setFatData(response.data);
      } catch (error) {
        console.log("Error during fat request", error);
      }
    };
    const fetchMeals = async () => {
      try {
        const response = await Axios.get(
          `${baseUrl}/report/diet_plan/meals/${shamsiDate}`,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setMealsData(response.data);
      } catch (error) {
        console.log("Error during meals request", error);
      }
    };
    if (userToken && shamsiDate) {
      fetchCarbohydrates();
      fetchProtein();
      fetchFat();
      fetchMeals();
    }
  }, [baseUrl, userToken, shamsiDate]);

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  const showModalHandler = () => {
    setShowQuestionModal(true);
  };

  const handleClose = () => {
    setShowQuestionModal(false);
  };

  const showDatePickerHandler = () => {
    setShowDatePicker(true);
  };

  const closeDatePicker = () => {
    setShowDatePicker(false);
  };

  const updateShamsiDate = async (selectedDate) => {
    setShamsiDate(selectedDate);
  };

  const showAlertHandler = () => {
    setShowAlert(true);
    if (manualCalculator) {
      setAlertText("کالری شمار دستی فعال شده است");
    } else {
      setAlertText("کالری شمار اتومات فعال شده است");
    }
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
  };

  const calorieRegulationHandler = () => {
    setShowCalorieRegulationModal(true);
  };

  const handleInputChange = (e) => {
    const numericValue =
      e.target.value === "" ? "" : parseFloat(e.target.value);
    setCalorieInputVal(isNaN(numericValue) ? "" : numericValue);
  };

  const handleIncrement = () => {
    setCalorieInputVal(calorieInputVal + 1);
  };

  const handleDecrement = () => {
    setCalorieInputVal(calorieInputVal - 1 >= 0 ? calorieInputVal - 1 : 0);
  };

  const handleSwitch = () => {
    setManualCalculator((prevState) => {
      const newManualCalculatorState = !prevState;
      if (newManualCalculatorState) {
        setSwitchAlertText("کالری شمار دستی");
      } else {
        setSwitchAlertText("کالری شمار اتومات");
      }
      setShowSwitchAlert(true);
      setTimeout(() => {
        setShowSwitchAlert(false);
      }, 2000);
      return newManualCalculatorState;
    });
  };

  const fetchCalorie = async () => {
    try {
      const response = await Axios.get(
        `${baseUrl}/report/diet_plan/calorie/${shamsiDate}`,
        {
          headers: {
            Authorization: `Token ${userToken}`,
          },
        }
      );
      setCalorieData(response.data);
    } catch (error) {
      console.log("Error during calorie request", error);
    }
  };

  const saveChangesHandler = () => {
    setShowCalorieRegulationModal(false);
    setShowAlert(true);
    setTimeout(() => {
      setShowAlert(false);
    }, 2000);
    const fetchPostAutoCalorie = async () => {
      const postData = {
        manual_calculate_calorie: manualCalculator,
        calorie_limit: calorieInputVal,
      };
      try {
        const response = await Axios.post(
          `${baseUrl}/report/diet_plan/auto_calorie`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
        setManualCalculator(response.data.manual_calculate_calorie);
        setCalorieData((prevCalorieData) => ({
          ...prevCalorieData,
          total_calorie: response.data.calorie_limit,
        }));
        setCarbohydratesData((prevCarbohydratesData) => ({
          ...prevCarbohydratesData,
          total_carbohydrates: response.data.calorie_limit,
        }));
        setProteinData((prevProteinData) => ({
          ...prevProteinData,
          total_protein: response.data.calorie_limit,
        }));
        setFatData((prevFatData) => ({
          ...prevFatData,
          total_fat: response.data.calorie_limit,
        }));
        fetchCalorie();
      } catch (error) {
        console.log("Error during posting auto calorie request", error);
      }
    };
    fetchPostAutoCalorie();
    if (manualCalculator) {
      setAlertText("کالری شمار دستی فعال شده است");
    } else {
      setAlertText("کالری شمار اتومات فعال شده است");
    }
  };
  
  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        {showDatePicker && (
          <MobileDatePicker
            label="calorie"
            date={shamsiDate}
            onClose={closeDatePicker}
            onSend={(selectedDate) => updateShamsiDate(selectedDate)}
          />
        )}
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          <div className="calorieCounterHeaderLeft centeredFlex">
            <Help
              showQuestionModal={showQuestionModal}
              onShow={showModalHandler}
              onHide={handleClose}
              data={calorieCounterHelp}
            />
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          </div>
          <div className="pageTitle horizontalBorder">کالری شمار آنلاین</div>
          <div className="scroll responsiveWidth">
            <CaloriesPerDay
              shamsiDate={shamsiDate}
              onShowDatePicker={showDatePickerHandler}
              onShowAlert={showAlertHandler}
              onShowCalorieRegulation={calorieRegulationHandler}
              calorieData={calorieData}
              manual={manualCalculator}
            />
            <Meals shamsiDate={shamsiDate} mealsData={mealsData} />
            <DailyFood
              carbohydrates={carbohydratesData}
              protein={proteinData}
              fat={fatData}
            />
            <MealsList shamsiDate={shamsiDate} mealsData={mealsData} />
            <CoachComments shamsiDate={shamsiDate} comment={comment} />
          </div>
          <Modal
            className="calorieRegulationModal"
            show={showCalorieRegulationModal}
            onHide={() => setShowCalorieRegulationModal(false)}
          >
            <Modal.Header closeButton className="calorieRegulationHeader">
              <Modal.Title className="calorieRegulationTitle">
                تنظیم نحوه محاسبه کالری
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="calorieRegulationModalBody centeredFlex">
              <button
                onClick={handleIncrement}
                className={`calorieRegulationPlusBtn centeredFlex ${
                  manualCalculator ? "" : "lowOpacity"
                }`}
                disabled={!manualCalculator}
              >
                <AddIcon className="calorieRegulationModalBodyIcon"  />
              </button>
              <input
                type="text"
                value={
                  calorieInputVal === "" ? "" : parseFloat(calorieInputVal)
                }
                onChange={handleInputChange}
                pattern="[0-9]*"
                inputMode="numeric"
                className={`calorieRegulationInput ${
                  manualCalculator ? "" : "lowOpacity"
                }`}
                disabled={!manualCalculator}
              />
              <button
                onClick={handleDecrement}
                className={`calorieRegulationMinusBtn centeredFlex ${
                  manualCalculator ? "" : "lowOpacity"
                }`}
                disabled={!manualCalculator}
              >
                <RemoveIcon className="calorieRegulationModalBodyIcon" />
              </button>
            </Modal.Body>
            <Modal.Footer className="calorieRegulationFooter centeredFlex">
              <div className="automaticOrManual centeredFlex">
                <div className="switchContainer">
                  <div className={`switch ${manualCalculator ? "" : "active"}`}>
                    <div className="circle" onClick={handleSwitch}></div>
                  </div>
                </div>
                <span>محاسبه خودکار</span>
              </div>
              <button
                className="dailyCaloriesSubmitBtn"
                onClick={saveChangesHandler}
              >
                ثبت تغییرات
              </button>
            </Modal.Footer>
          </Modal>
          <Alert showAlert={showAlert} alertText={alertText} bottom="5rem" />
          <Alert showAlert={showSwitchAlert} alertText={switchAlertText} bottom="5rem" />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
